// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"toggleTabs_tabsWrapper__D+oep","tab":"toggleTabs_tab__LxQk+","active":"toggleTabs_active__v4wva"};